<!-- <div class="flex flex-row">
  <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div> -->
<div class="pt-24 pl-72 pr-72">
  <app-breadcrumb class="mt-16" [items]="breadcrumbItems"></app-breadcrumb>
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-row justify-start items-center mb-12">
      <mat-icon svgIcon="arrow_back" class="cursor-pointer icon-lg" [routerLink]="['/', tenant, RouterSegments.TENANT, tenantId, RouterSegments.SOLUTION]"></mat-icon>
      <div class="mat-headline-5 m-0 ml-8 ml-24">{{'SOLUTIONS.VIEW_BUILD_VERSIONS' | transloco }}</div>
    </div>
    <div class="flex flex-row justify-center items-center">
      <div>
        <button class="flex justify-center items-center context-menu-icon pl-6 pr-16 disabled">
          <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
          <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
        </button>
      </div>
      <div class="hide">
        <button *ngIf="permissionsMap[Permission.ADD_SOLUTION_VERSION]" (click)="addNewBuildVersion()" type="button" class="flex justify-center items-center tenant-gradient mat-subtitle-2 fw-700 m-0 pl-16 pr-16"
           mat-button>
          <mat-icon svgIcon="add" class="icon-md-2 pr-4"></mat-icon>
          {{'SOLUTIONS.ADD_BUILD_VERSION' | transloco }}
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="!showSpinner && solutionVersions">
    {{'SOLUTIONS.SOLUTION_NAME' | transloco }}: <span class="solution-name">{{solutionName}}</span>
  </div>

  <div class="mt-24">
    <div *ngIf="!showSpinner && !isFailed" class="flex flex-col version-table">
      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="mat-elevation">
        <ng-container matColumnDef="version">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'SOLUTIONS.VERSION' | transloco | uppercase }} </th>
          <td mat-cell *matCellDef="let data" class="cursor-pointer fw-600 version-name" (click)="versionNameClick(data)"> {{data?.version}} </td>
        </ng-container>

        <ng-container matColumnDef="releaseVersion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'SOLUTIONS.RELEASE_VERSION' | transloco | uppercase }} </th>
          <td mat-cell *matCellDef="let data"> {{data?.releaseVersion ? data?.releaseVersion : '-'}} </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'SOLUTIONS.DESCRIPTION' | transloco | uppercase }} </th>
          <td mat-cell *matCellDef="let data"> {{data?.description ? data?.description : '-'}} </td>
        </ng-container>

        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'SOLUTIONS.CREATED_ON' | transloco | uppercase }}</th>
          <td mat-cell *matCellDef="let data"> {{dateTimeFormatService.getUtcFromat(data?.dateCreated)}} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'SOLUTIONS.STATUS' | transloco | uppercase }} </th>
          <td mat-cell *matCellDef="let data">
            <div class="flex items-center">
              <span class="sucess-circle mr-6" *ngIf="data?.status === SolutionStatus.PUBLISHED">
                <mat-icon svgIcon="done" class="icon-sm p-2"></mat-icon>
              </span>
              <span class="status">{{data?.status | titlecase}}</span>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <app-paginator class="p-16" *ngIf="showPagination" [length]="solutionVersions?.length" [pageSizeOptions]="[10, 15, 20]"
        [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChanged($event)">
      </app-paginator>

      <div *ngIf="solutionVersions?.length === 0 && !showSpinner && !isFailed" class="flex justify-center pb-32">
        {{'SOLUTIONS.NO_VERSION_MESSAGE' | transloco }}
      </div>
    </div>

    <div *ngIf="isFailed" class="flex justify-center top-panel p-50">
      {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
    </div>

    <mat-card *ngIf="showSpinner" class="flex spinner-container spinner p-30">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </mat-card>
  </div>
</div>
